/**
 * Coerces a zip/postal code value into a display-ready string, restoring the
 * leading zeros that ESDB strips.
 *
 * ESDB stores branch zip codes as integers, so the es-api branch response
 * returns `zip_code` as a number — a leading-zero zip like 02134 arrives as the
 * number 2134, dropping the zero before it ever reaches the client. JSON
 * parsing has already discarded the zero, so the original can't truly be
 * recovered; we rebuild the canonical 5-digit US form by left-padding.
 *
 * We do not support ZIP+4 extensions, so a minimum width of 5 is correct:
 * - all-digit values shorter than 5 are padded (2134 -> "02134", 501 -> "00501")
 * - values already 5+ digits are returned unchanged (padStart is a no-op)
 * - non-numeric postal codes (e.g. Canadian "K1A 0B1") pass through untouched
 * - null/undefined become an empty string
 *
 * @param value - The raw zip/postal code value (string, number, or nullish)
 * @returns The coerced, display-ready zip/postal code string
 */
export function coerceZipCode( value: unknown ): string {
	const str = value == null ? '' : String( value )
	return /^\d+$/.test( str ) ? str.padStart( 5, '0' ) : str
}
